const MODULE_NAME = 'eszkozKalkulatorService';
class EszkozKalkulatorService {
	constructor($http, environment) {
		'ngInject';
		this._$http = $http;
		this._environment = environment; 
	}
	init() {
		return this._$http.get(`${this._environment.backendUrl}/do/kalkulator/eszkoz/init`);
	}
	kalkulal(request, success, error) {
		this._$http.post(`${this._environment.backendUrl}/do/kalkulator/eszkoz/kalkulal`, request).then(function (response) {
			success(response);
		}, function (response) {
			error(response);
		});
	}
	erdekel(request, success, error) {
		this._$http.post(`${this._environment.backendUrl}/do/kalkulator/eszkoz/erdekel`, request).then(function (response) {
			response = Object.keys(response).map(key => response[key]);
			success(response);
		}, function (response) {
			error(response);
		});
	}
}

export default angular.module(MODULE_NAME, [])
	.service('eszkozKalkulatorService', EszkozKalkulatorService).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/eszkozkalkulator-service.js